export enum ProductFormat {
  POCKET = "POCKET",
  STANDARD = "STANDARD",
  LARGE = "LARGE",
  HARDCOVER = "HARDCOVER",
}

export enum ProductStatus {
  PAUSE = "PAUSE",
  PROCESS = "PROCESS",
  DELETE = "DELETE",
}

export enum ProductGenre {
  NOVEL = "NOVEL",
  CLASSIC = "CLASSIC",
  FICTION = "FICTION",
  BIOGRAPHY = "BIOGRAPHY",
  OTHER = "OTHER",
}

export enum ProductSort {
  NEW = "NEW",
  PRICE = "PRICE",
  VIEWS = "VIEWS",
}

/** Compatibility aliases used by older components */
export { ProductFormat as ProductSize, ProductGenre as ProductCollection };
